import '../styles/site.scss';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import {playMidiNotes, playMidiChord} from './Audio';
import {initializeSharing} from './Share';
import {initializeAudioNotice} from './AudioNotice';

export {playMidiNotes, playMidiChord, prepareAudio} from './Audio';

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }
gtag('js', new Date());
gtag('config', 'G-TXQ613FSL6');

async function initialize() {
    let createPlaybackHighlight;
    initializeAudioNotice();
    initializeSharing(gtag);
    document.querySelectorAll('.collapse').forEach(element => new Collapse(element, {toggle: false}));
    document.querySelectorAll('.dropdown-toggle').forEach(element => new Dropdown(element));

    // Bind before asynchronous imports: audio unlock stays inside the user gesture.
    document.addEventListener('click', event => {
        const button = event.target.closest('[data-midi-notes]');
        if (!button) return;
        if (button.closest('[data-audio-calibration]')) return;
        event.preventDefault();
        const notes = JSON.parse(button.dataset.midiNotes);
        const card = button.closest('.chart-item');
        const highlight = createPlaybackHighlight?.(card || document, Boolean(card));
        if (button.dataset.playMode === 'chord') playMidiChord(notes, highlight);
        else playMidiNotes(notes, highlight);
    });

    const charts = document.querySelectorAll('[data-chart]');
    if (charts.length) {
        const renderer = await import(/* webpackChunkName: "charts" */ './Charts');
        createPlaybackHighlight = renderer.createPlaybackHighlight;
        renderer.drawCharts(charts, (semitone, highlight) => playMidiNotes([semitone + 40], highlight));
    }
    const calibration = document.querySelector('[data-audio-calibration]');
    if (calibration) {
        const {initializeAudioCalibration} = await import(/* webpackChunkName: "audio-calibration" */ './AudioCalibration');
        initializeAudioCalibration(calibration, createPlaybackHighlight);
    }
    const noteGame = document.querySelector('[data-note-game]');
    if (noteGame) {
        const {drawNoteGame} = await import(/* webpackChunkName: "note-game" */ './NoteGame');
        drawNoteGame(noteGame, playMidiNotes);
    }
    const chordGame = document.getElementById('chord-game-data');
    if (chordGame) {
        const {drawChordGame} = await import(/* webpackChunkName: "chord-game" */ './ChordGame');
        drawChordGame(JSON.parse(chordGame.textContent));
    }
}

function start() {
    initialize().catch(error => console.error('Unable to initialize Guitar Charts', error));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
else start();
